import { render, staticRenderFns } from "./UsuarioBusca.vue?vue&type=template&id=3e1462c8"
import script from "./UsuarioBusca.vue?vue&type=script&lang=js"
export * from "./UsuarioBusca.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports